import {FC} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../modules/auth'
import {
  actingShopBranch,
  branchesOf,
  canChooseBranch,
  setActingBranch,
} from '../modules/common/actingBranch'

/**
 * Mart v2: the branch this account is working for, in the header bar. An all-branches user of a
 * supplier with several shops picks it here — every screen then answers for that branch (shelf,
 * branch price, discounts), so the page reloads on a change. A user tied to a branch sees which one.
 * Renders nothing for a supplier with one shop or none.
 */
const BranchSwitcher: FC = () => {
  const {formatMessage} = useIntl()
  const {currentUser} = useAuth()
  const branches = branchesOf(currentUser)
  const acting = actingShopBranch(currentUser)
  if (branches.length < 2 || !acting) {
    return null
  }

  const label = (b: {branch_name: string; name: string}) => b.branch_name || b.name

  if (!canChooseBranch(currentUser)) {
    return (
      <span className='badge badge-light-primary fs-7 me-3' data-testid='branch-fixed'>
        {formatMessage({id: 'branch.working_at'}, {branch: label(acting)})}
      </span>
    )
  }

  return (
    <label className='d-flex align-items-center gap-2 me-3 mb-0'>
      <span className='text-gray-600 fs-7 text-nowrap'>{formatMessage({id: 'branch.label'})}</span>
      <select
        className='form-select form-select-sm form-select-solid'
        value={acting.branch_id}
        onChange={(e) => {
          setActingBranch(Number(e.target.value))
          window.location.reload()
        }}
        aria-label={formatMessage({id: 'branch.label'})}
      >
        {branches.map((b) => (
          <option key={b.branch_id} value={b.branch_id}>
            {label(b)}
            {b.is_main ? ` (${formatMessage({id: 'branch.main'})})` : ''}
          </option>
        ))}
      </select>
    </label>
  )
}

export default BranchSwitcher
